import type { ActivationAlertsMetricsSocialMediaActivityAndAudienceDetailData } from "@similarweb/pro-api-client";

import type { ValueMap } from "../../common/widget/table/computeLeaders";
import { addToValueMap, getLeadersFromMap } from "../../common/widget/table/computeLeaders";
import type { ActivityAndAudienceRow } from "../metrics/activity-and-audience/types";

const computeLeaders = (data: ActivationAlertsMetricsSocialMediaActivityAndAudienceDetailData) => {
    const totalPostsMap: ValueMap = new Map();
    const audienceSizeMap: ValueMap = new Map();
    const avgSviMap: ValueMap = new Map();

    data.forEach((item) => {
        addToValueMap({ map: totalPostsMap, value: item.totalPosts.volume, domain: item.domain });
        addToValueMap({ map: audienceSizeMap, value: item.audienceSize.followers, domain: item.domain });
        addToValueMap({ map: avgSviMap, value: item.avgSocialValueIndex, domain: item.domain });
    });

    return {
        totalPosts: getLeadersFromMap(totalPostsMap),
        audienceSize: getLeadersFromMap(audienceSizeMap),
        avgSocialValueIndex: getLeadersFromMap(avgSviMap),
    };
};

export const transformActivityAndAudienceData = ({
    data,
    icons,
    primaryDomain,
}: {
    data: ActivationAlertsMetricsSocialMediaActivityAndAudienceDetailData;
    icons: Record<string, string> | undefined;
    primaryDomain?: string;
}): ActivityAndAudienceRow[] => {
    const leaders = computeLeaders(data);

    return data.map((row) => ({
        domain: {
            icon: icons?.[row.domain],
            isPrimary: row.domain === primaryDomain,
            value: row.domain,
        },
        totalPosts: {
            volume: row.totalPosts.volume,
            change: row.totalPosts.change,
            isLeader: leaders.totalPosts.has(row.domain),
        },
        audienceSize: {
            followers: row.audienceSize.followers,
            change: row.audienceSize.change,
            isLeader: leaders.audienceSize.has(row.domain),
        },
        avgSocialValueIndex: {
            value: row.avgSocialValueIndex,
            isLeader: leaders.avgSocialValueIndex.has(row.domain),
        },
    }));
};
